module.exports = __webpack_public_path__ + "img/ring_a-2097@2x.60de8e9.webp";